/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pm_No_PortalsInputs */

const cs_pm_no_portals = /** @type {(inputs: Pm_No_PortalsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nemáte připojený žádný portál, na který exportujeme. Připojte ho v Integrace › Portály.`)
};

const en_pm_no_portals = /** @type {(inputs: Pm_No_PortalsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No push portal is connected. Connect one under Integrations › Portals.`)
};

/**
* | output |
* | --- |
* | "No push portal is connected. Connect one under Integrations › Portals." |
*
* @param {Pm_No_PortalsInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const pm_no_portals = /** @type {((inputs?: Pm_No_PortalsInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pm_No_PortalsInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pm_no_portals(inputs)
	return cs_pm_no_portals(inputs)
});